(() => {
  const selector = '.quick-add__submit[data-product-url], .zj-explorer__quick-button[data-product-url]';
  const buyingCopy = 'Make it yours';

  function update(button) {
    if (!button || button.disabled) return;

    const directText = Array.from(button.childNodes).find(
      node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );

    if (directText) {
      if (directText.textContent.trim() !== buyingCopy) {
        directText.textContent = ` ${buyingCopy} `;
      }
      button.setAttribute('aria-label', buyingCopy);
      return;
    }

    const textSpan = Array.from(button.children).find(
      el => el.tagName === 'SPAN' &&
        !el.classList.contains('loading__spinner') &&
        !el.classList.contains('icon-wrap') &&
        !el.classList.contains('sold-out-message')
    );

    if (textSpan && textSpan.textContent.trim() !== buyingCopy) {
      textSpan.textContent = buyingCopy;
    }
    button.setAttribute('aria-label', buyingCopy);
  }

  function polish(root = document) {
    if (root.matches?.(selector)) update(root);
    root.querySelectorAll?.(selector).forEach(update);
  }

  function boot() {
    polish(document);
    document.addEventListener('shopify:section:load', event => polish(event.target));

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) polish(node);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
